import { useState, useEffect } from 'react';

interface GeocodingResult {
  address: string;
  loading: boolean;
  error: string | null;
}

export const useReverseGeocoding = (lat: number, lng: number): GeocodingResult => {
  const [result, setResult] = useState<GeocodingResult>({
    address: '',
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        const accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${accessToken}&language=fr`
        );
        
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération de l\'adresse');
        }

        const data = await response.json();
        const address = data.features[0]?.place_name || 'Adresse non trouvée';
        
        setResult({
          address,
          loading: false,
          error: null
        });
      } catch (error) {
        setResult({
          address: '',
          loading: false,
          error: error instanceof Error ? error.message : 'Une erreur est survenue'
        });
      }
    };

    fetchAddress();
  }, [lat, lng]);

  return result;
};

